export default "__VITE_ASSET__MzB2J9Ng__"